/* eslint-disable react/prop-types */
import React from "react";

export default React.memo(({ position }) => {
  // convert position to translate offset
  const offset = `${position[0] * 40 + 20}, ${position[1] * 40 + 20}`;
  return <circle cx="3" cy="3" r="20" transform={`translate(${offset})`} />;
});
